import { render, staticRenderFns } from "./OpcionIcon.vue?vue&type=template&id=157d13a5"
import script from "./OpcionIcon.vue?vue&type=script&lang=js"
export * from "./OpcionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports